export default {
  agree_links: {
    services: 'Allgemeinen Geschäftsbedingungen',
    policy: 'Datenschutzerklärung',
    all_text:
      'Ich habe die {services} samt Widerrufsbelehrung in Punkt 10 sowie die {policy} gelesen und verstanden und stimme diesen uneingeschränkt zu.',
    all_text_1:
      'Ich habe die {services} samt Widerrufsbelehrung in Punkt 10 gelesen und verstanden und stimme diesen uneingeschränkt zu.',
    all_text_2:
      'Weitere Informationen zur Datenverarbeitung finden Sie in unserer {policy}.',
  },
  agree_text: 'Ich stimme den AGBs und der Datenschutzerklärung zu ?',
}
